export default __webpack_public_path__ + "static/media/villa_6.f7b67776.jpg";